import { z } from "zod/v4";

export const currencySchema = z.enum(["EUR", "USD", "CHF"]);
